export enum ShiftAction {
  UP,
  DOWN,
}
